import type { SxProps, Theme } from '@mui/material/styles';

const snapshotSummaryStyles = {
  root: {
    mt: 10,
    pl: 2,
    pr: 2
  },
  backIcon: {
    fontSize: 32
  },
  goBackTypography: {
    cursor: 'pointer'
  },
  mainStack: {
    overflow: 'hidden',
    height: '85vh'
  },
  contentCard: {
    borderRadius: '4px',
    bgcolor: '#fff',
    mt: 4,
    p: 2,
    boxShadow:
      '0px 2px 1px -1px rgba(0,0,0,0.2), 0px 1px 1px 0px rgba(0,0,0,0.14), 0px 1px 3px 0px rgba(0,0,0,0.12)'
  },
  pdfLoadingWrapper: {
    height: '100%',
    position: 'relative' as const
  },
  pdfLoadingCenter: {
    position: 'absolute' as const,
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)'
  },
  snackbarError: {
    '& .MuiSnackbarContent-root': { backgroundColor: 'error.main' }
  },
  snackbarSuccess: {
    '& .MuiSnackbarContent-root': { backgroundColor: 'success.main' }
  }
} as const satisfies Record<string, SxProps<Theme>>;

export default snapshotSummaryStyles;
